<template>
    <div class="container pt-4 app-content">
        <app-header></app-header>
        <div class="row container-fluid">
            <main>
                <router-view></router-view>
            </main>
        </div>
        <footer-menu :isAuth="isAuth" :displayLogin="displayLogin"></footer-menu>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import AuthUtil from '../utils/AuthUtil';
    import AppHeader from '../components/AppHeader/AppHeader.vue';
    import AppFooter from '../components/AppFooter/AppFooter.vue';
    import FooterMenu from '../components/FooterMenu/FooterMenu.vue';
    import UserService from '../services/UserService';

    export default {
        name: 'child-layout',

        components: {
            AppHeader,
            AppFooter,
            FooterMenu
        },

        data() {
            return {
                isAuth: false,
                displayLogin: true,
            }
        },

        async created() {
            this.isAuth = AuthUtil.isAuth();
            this.pageAuth = this.$route.meta.auth;

            if (this.pageAuth) {
                await this.fetchUserFrontendData();
            }
        },

        mounted() {
        },

        methods: {
            async fetchUserFrontendData() {
                const user = (await UserService.getUserFrontendData(true)).data;
                if (
                    user.is_child &&
                    !user.changed_password &&
                    (this.$router.path === '/child/change-password')
                ) {
                    this.$router.push('/settings');
                }
            }
        }
    }
</script>
